import { memo, ReactNode } from 'react';
import { SystemClassifierItemDto } from './index';
import { useSystemClassifierItemById } from '../configuration';

export interface SystemClassifierItemProps {
  code: string;
  itemId?: number;
  render?: (item?: SystemClassifierItemDto) => ReactNode;
}

export const SystemClassifierItem = memo(
  ({ code, itemId, render }: SystemClassifierItemProps) => {
    const item = useSystemClassifierItemById(code, itemId);

    if (render) {
      return render(item);
    }

    return item?.name;
  }
);
